module.exports = __webpack_public_path__ + "img/trash-02.69540200.svg";